import React, { useState, ChangeEvent } from 'react';
import { useHasura } from 'context/ApiState';
import { ReactComponent as OfficeIcon } from 'assets/icons/icon-office.svg';
import SearchInput from 'components/SearchInput';
import Checkbox from 'components/Checkbox';

const BankOrgPermissions = ({ bank }) => {
  const [filter, setFilter] = useState('');
  const [pending, setPending] = useState([]);

  const {
    organisations,
    organisationBanks,
    addOrganisationBank,
    removeOrganisationBank,
    state,
  } = useHasura();

  return (
    <div className="card">
      <div className="cardBody">
        <aside>
          <h2 className="mb-4 text-lg text-gray-800">
            Associated Organisations
          </h2>
          <SearchInput
            placeholder="Filter"
            value={filter}
            onResetClick={() => setFilter('')}
            onChange={(e: ChangeEvent<HTMLInputElement>) => {
              setFilter(e.currentTarget.value);
            }}
          />
          <p className="mt-4 text-sm">
            Organisations that can view this Bank and any Factsheets for this
            Bank
          </p>
        </aside>
        <main>
          <div className="flex flex-wrap wrapper-fixed-height">
            {organisations
              ?.filter((organisation) =>
                organisation?.name
                  ?.toLowerCase()
                  .includes(filter.toLowerCase()),
              )
              ?.map((organisation, i) => {
                const checked = !!organisationBanks?.find(
                  (ob) =>
                    organisation?.id === ob?.organisation_id &&
                    bank?.id === ob?.bank_id,
                );

                const togglePermission = (event) => {
                  event.preventDefault();
                  // console.log(event.target.checked);
                  pending[i] = true;
                  if (checked) {
                    // remove row from OrganisationBanks
                    removeOrganisationBank({
                      bank_id: bank?.id,
                      orgId: organisation?.id,
                    }).finally(() => {
                      pending[i] = false;
                    });
                  } else {
                    // add row to OrganisationBanks
                    addOrganisationBank({
                      bank_id: bank?.id,
                      orgId: organisation?.id,
                    }).finally(() => {
                      pending[i] = false;
                    });
                  }
                  pending[i] = false;
                };

                return (
                  <div
                    key={i}
                    className={`w-full xl:w-1/2 border-4 border-white h-12 rounded-lg flex items-center cursor-pointer mb-2 overflow-hidden
                  ${pending[i] ? 'text-gray-200 bg-white' : ''}
                  ${
                    pending[i]
                      ? 'text-gray-300 bg-gray-200'
                      : checked
                      ? 'text-jcap-500 bg-jcap-100'
                      : 'text-gray-500 bg-gray-100'
                  }`}
                    onClick={togglePermission}
                  >
                    <OfficeIcon className="inline w-6 h-6 mx-3 mb-1 pointer-events-none" />
                    <div className="flex flex-col flex-grow pr-1 truncate pointer-events-none select-none">
                      <p className="text-sm font-semibold truncate">
                        {organisation?.name}
                      </p>
                    </div>
                    <Checkbox
                      checked={checked}
                      onChange={() => {}}
                      className={`w-8 h-8 rounded-full p-1 mr-3 bg-white text-jcap-500 ${
                        checked ? 'bg-jcap-100' : 'bg-gray-100'
                      }`}
                    />
                  </div>
                );
              })}
          </div>
        </main>
      </div>
    </div>
  );
};

export default BankOrgPermissions;
